import { ISeasonMapping } from './algorithm/algoInterface'

export const seasonMapping: ISeasonMapping = {
  3: 'spr',
  4: 'spr',
  5: 'spr', // 3월, 4월, 5월은 spring
  6: 'sum',
  7: 'sum',
  8: 'sum', // 6월, 7월, 8월은 summer
  9: 'fall',
  10: 'fall', // 9월, 10월은 fall
  11: 'win',
  12: 'win',
  1: 'win',
  2: 'win', // 11월, 12월, 1월, 2월은 winter
}
